import { render } from "./PageHeroBanner.vue?vue&type=template&id=4e072edc&scoped=true"
import script from "./PageHeroBanner.vue?vue&type=script&lang=js"
export * from "./PageHeroBanner.vue?vue&type=script&lang=js"

import "./PageHeroBanner.vue?vue&type=style&index=0&id=4e072edc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e072edc"]])

export default __exports__